
  import { Component, Vue } from 'vue-property-decorator';
  import {IApp} from "@/interfaces/app.interface";

  @Component({})
  export default class PageNotFound extends Vue {
    isLoading: boolean = true;

    async created () {
      await this.$store.dispatch('auth/init');
      await this.$store.dispatch('initialized');
      this.isLoading = false;
    }

    async openPage() {
      await this.$store.dispatch('openPage', {routeName: IApp.ROUTE_NAME.HOME});
    }
  }
